import React, { useEffect, useState, useContext, useRef, useMemo, useCallback, useLayoutEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import { BASELINE, AFTER_LOGIN } from "../../util/index";
import { BsTrash } from 'react-icons/bs';
import { Navigate } from "react-router-dom";
import { FaPencilAlt } from "react-icons/fa";
import { toast } from "react-hot-toast";
import { motion } from "framer-motion";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, LineElement, PointElement, Filler } from 'chart.js';
import TestList from "./testlist";
import CircleGraph from './circlegraph'; // Import the CircleGraph component
import SDM from "./student_dashboard_menu";
import MainDashboard from "./main_dashboard";
import DigitalSatView from "./SAT/DigitalSatView";
import DigitalActView from "./ACT/DigitalActView";
import DigitalNMSQTView from "./SAT10/DigitalNMSQTView";
import DigitalSAT89View from "./SAT89/DigitalSAT89View";
import DigitalAPABView from "./APCALCAB/DigitalAPCalcView";
import DigitalAPBCView from "./APCALCBC/DigitalAPBCCalcView";

import RandomSATReady from "./SAT/Dashboard_SAT";
import RandomACTReady from "./ACT/Dashboard_ACT";
import RandomNMSQTReady from "./SAT10/Dashboard_NMSQT";
import RandomSAT89Ready from "./SAT89/Dashboard_SAT89";
import RandomAPCALCABReady from "./APCALCAB/Dashboard_AP_CALC_AB";
import RandomAPCALCBCReady from "./APCALCBC/Dashboard_AP_CALC_BC";

import OverallACTANAL from "./ACT/OverallACTANAL";
import OverallNMSQTAnal from "./SAT10/OverallNMSQTANAL";
import OverallSAT89Anal from "./SAT89/OverallSAT89ANAL";
import OverallABAnal from "./APCALCAB/OverallAPABANAL";
import OverallBCAnal from "./APCALCBC/OverallAPBCANAL";

import DashboardAI from "./AI_Chat/Dashboard_AI";
import StudentDashboard from "./class_list";
import HomeworkView from "./classview";

import GetHelp from "./get_help";
import { FaAnglesLeft } from "react-icons/fa6";
import { FaAnglesRight } from "react-icons/fa6";
import { BsFileEarmarkX } from "react-icons/bs";
import { RiEditFill } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import AnimatedCounter from "./count_animation";
import QuizResult from "./quiz_result_table";
import { Feedback } from "../../Components/FeedBack/feedback";
import TestDisplayComponent from './TestDisplayComponent';
import TabsSection from './TabsSection';

ChartJS.register(BarElement, CategoryScale, LinearScale, LineElement, PointElement, Filler);

const Pagination = ({ currentPage, pageCount, setPage, light }) => {
  if (pageCount <= 1) return null;
  return (
    <div className="flex justify-center items-center gap-2 mt-4 pb-4">
      <button
        onClick={() => setPage(currentPage - 1)}
        disabled={currentPage === 0}
        className={`flex items-center justify-center w-9 h-9 rounded-xl border transition-all duration-200 disabled:opacity-25 disabled:cursor-not-allowed ${
          light
            ? 'border-slate-200 bg-white text-slate-400 hover:bg-slate-50 hover:text-slate-700'
            : 'border-white/10 bg-white/[0.05] text-white/50 hover:bg-white/[0.10] hover:text-white'
        }`}
      >
        <FaChevronLeft size={12} />
      </button>
      {Array.from({ length: pageCount }, (_, i) => (
        <button
          key={i}
          onClick={() => setPage(i)}
          className={`w-9 h-9 rounded-xl border text-sm font-semibold transition-all duration-200 ${
            light
              ? i === currentPage
                ? 'bg-blue-600 border-blue-600 text-white shadow-sm shadow-blue-200'
                : 'bg-white border-slate-200 text-slate-500 hover:border-blue-300 hover:text-blue-600'
              : i === currentPage
                ? 'bg-blue-500/25 border-blue-400/40 text-blue-300 shadow-sm shadow-blue-500/20'
                : 'bg-white/[0.04] border-white/10 text-white/50 hover:bg-white/[0.09] hover:text-white'
          }`}
        >
          {i + 1}
        </button>
      ))}
      <button
        onClick={() => setPage(currentPage + 1)}
        disabled={currentPage === pageCount - 1}
        className={`flex items-center justify-center w-9 h-9 rounded-xl border transition-all duration-200 disabled:opacity-25 disabled:cursor-not-allowed ${
          light
            ? 'border-slate-200 bg-white text-slate-400 hover:bg-slate-50 hover:text-slate-700'
            : 'border-white/10 bg-white/[0.05] text-white/50 hover:bg-white/[0.10] hover:text-white'
        }`}
      >
        <FaChevronRight size={12} />
      </button>
    </div>
  );
};

const LoadingScreen = () => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
    color: 'white',
    fontSize: '24px',
    zIndex: 1000, // High z-index to cover everything else
  }}>
    Loading...
  </div>
);

const Dashboard = ({ s_uid, smallmode, parents }) => {
  const [esubjects, esetSubjects] = useState([
    {
      name: 'Information and Ideas', count: 0, isOpen: true, isSelected: false, tag: 'English',
      subTopics: [
        { name: 'Inferences', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Central Ideas and Details', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Command of Evidence', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Craft and Structure', count: 0, isOpen: true, isSelected: false, tag: 'English',
      subTopics: [
        { name: 'Words in Context', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Text Structure and Purpose', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Cross-Text Connections', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Expression of Ideas', count: 0, isOpen: true, isSelected: false, tag: 'English',
      subTopics: [
        { name: 'Rhetorical Synthesis', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Transitions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } }
      ]
    },
    {
      name: 'Standard English Conventions', count: 0, isOpen: true, isSelected: false, tag: 'English',
      subTopics: [
        { name: 'Boundaries', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Form, Structure, and Sense', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } }
      ]
    }
  ]);

  const [msubjects, msetSubjects] = useState([
    {
      name: 'Algebra', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Linear functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Systems of two linear equations in two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Linear inequalities in one or two variables', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Linear equations in one variable', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Advanced Math', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Nonlinear functions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Equivalent expressions', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Problem-solving and Data Analysis', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Ratios, rates, proportional relationships, and units', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Probability and conditional probability', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'One-variable data: Distributions and measures of center and spread', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Two-variable data: Models and scatterplots', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Percentages', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    },
    {
      name: 'Geometry and Trigonometry', count: 0, isOpen: true, isSelected: false, tag: 'Math',
      subTopics: [
        { name: 'Lines, angles, and triangles', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Right triangles and trigonometry', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
        { name: 'Area and volume', count: 0, isSelected: false, toggle: function () { this.isSelected = !this.isSelected; } },
      ]
    }
  ]);

  const boxItemLeftRef = useRef();
  const [activeTab, setActiveTab] = useState('all');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { logoutUser, user, setid, clearLocalStorageExceptUser } = useContext(UserContext);

  const navigate = useNavigate();
  const location = useLocation();
  const { section: urlSection, classid: urlClassid, tab: urlTab, courseSlug: urlCourseSlug } = useParams();

  const [selectedTest, setSelectedTest] = useState(null);
  const [testResults, setTestResults] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState([]);
  const [picked, setPicked] = useState('');
  const [questionid, setQuestionid] = useState('');
  const [tag, settag] = useState('');

  const [selectedTypes, setSelectedTypes] = useState(['SAT']);
  const filteredTests = testResults.filter(test => selectedTypes.includes(test.type));
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(0);
  const pageCount = Math.ceil(filteredTests.length / itemsPerPage);
  const currentTests = filteredTests.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const [hideExplanation, setHideExplanation] = useState(false);
  const handleChange = () => {
    setHideExplanation(!hideExplanation);
  };
  const [c_ans, set_cans] = useState(0);
  const [w_ans, set_wans] = useState(0);
  const [engtag, setengtag] = useState([]);
  const [mathtag, setmathtag] = useState([]);
  const [readingtag, setreadingtag] = useState([]);
  const [sciencetag, setsciencetag] = useState([]);

  const [eng, seteng] = useState(0);
  const [math, setmath] = useState(0);
  const [missing_topics, setMissing_topics] = useState([]);
  const [autosave, setAutosave] = useState([]);
  const [homework, setHomework] = useState([]);
  const [dashboard, setdashboard] = useState(() => location.state?.goTo ?? 0);
  const [prevDashboard, setPrevDashboard] = useState(dashboard);
  const [direction, setDirection] = useState(1);

  const [lastTest, setLastTest] = useState("???");
  const [laste, setlaste] = useState("???");
  const [lastm, setlastm] = useState("???");

  const [percentage, setPercentage] = useState(0);

  const maxScore = 1600;

  const [isOpen, setIsOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [testName, setTestName] = useState("");
  const [testType, setTestType] = useState('SAT');  // State to track the selected test type
  const [avg_sat, setavg_sat] = useState(0);
  const [avg_eng, setavg_eng] = useState(0);
  const [avg_math, setavg_math] = useState(0);
  const [Incorrect_questionIds, setIncorrect_questionIds] = useState([]);
  const [Correct_questionIds, setCorrect_questionIds] = useState([]);
  const [allSATScores, setAllSATScores] = useState([]);
  const [allengscores, setallengscores] = useState([]);
  const [allmathscores, setallmathscores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actscores, setactscores] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [overview, setoverview] = useState([]);
  const [index, setindex] = useState(0);
  const [type, settype] = useState("");
  const cleanOptionText = (text) => text.substring(3);
  const [soptions, setoptions] = useState([]);
  const [expand, setexpand] = useState(false);
  const [shortid, setshortid] = useState("");
  const [aiquestion, setaiquestion] = useState("");
  const [mocksatreview, setmocksatreview] = useState("");
  const [satanal, setsatanal] = useState("");
  const [isEditingName, setIsEditingName] = useState(false);
  const [editingTestId, setEditingTestId] = useState(null);
  const [editedTestName, setEditedTestName] = useState("");

  const handleSaveTestName = async (test) => {
    try {
      const response = await axios.post(`${BASELINE}updateaudosavebyid`, {
        testid: test.testid,
        name: editedTestName,
      });
      if (response.status === 200) {
        toast.success("Test name updated successfully");
        // Update the autosave state with the new name for the matching test
        setAutosave((prevAutosave) =>
          prevAutosave.map((item) =>
            item.testid === test.testid ? { ...item, name: editedTestName } : item
          )
        );
        setEditingTestId(null);
      }
    } catch (error) {
      toast.error("Failed to update test name");
      console.error(error);
    }
  };

  useEffect(() => {
    // dashboard가 변경될 때, 이전 값과의 차이를 계산
    const diff = dashboard - prevDashboard;
    setDirection(diff >= 0 ? 1 : -1);
    // 이전값 업데이트
    setPrevDashboard(dashboard);
  }, [dashboard]);

  useEffect(() => {
    setCurrentPage(0);
  }, [selectedTypes]);

  useEffect(() => {
    if (!user) return;

    // get completed tests
    const fetchTestResults = async () => {
      try {
        const { data } = await axios.post(BASELINE + "testresult/get", {
          id: user.u_id,
        });
        setTestResults(data);
      } catch (error) {
        console.error(error);
      }
    };

    // get autosave
    const fetchAutosave = async () => {
      try {
        const { data } = await axios.get(BASELINE + "getautosave", {
          params: { id: user.u_id },
        });

        setAutosave(data.data);
      } catch (error) {
        console.error(error);
      }
    };

    if (smallmode !== true) {
      if (user?.role === 'parents' || user?.role === 'teacher') {
        navigate('/');
      }
    } else {
      setdashboard(2);
      fetchTestResults();
      fetchAutosave();
    }

  }, [user]);

  const urlSectionMap = {
    sat:      { mainPath: 1,  type: 'SAT',      select: 'SAT',        activeIndex: 1  },
    act:      { mainPath: 6,  type: 'ACT',      select: 'ACT',        activeIndex: 6  },
    apcalcab: { mainPath: 18, type: 'APCALCAB', select: 'AP_Calc_AB', activeIndex: 18 },
    apcalcbc: { mainPath: 22, type: 'APCALCBC', select: 'AP_Calc_BC', activeIndex: 22 },
    sat89:    { mainPath: 14, type: 'PSAT89',   select: 'SAT89',      activeIndex: 14 },
    nmsqt:    { mainPath: 10, type: 'NMSQT',    select: 'SAT10',      activeIndex: 10 },
  };

  // tab name → dashboard index offset from mainPath
  const tabOffset = { main: 0, result: 1, practice: 2, resume: 4 };
  const knownNavTabs = new Set(['main', 'result', 'practice', 'resume', 'courses']);

  // /main/sat/:classid route intercepts /main/sat/result — detect and reroute
  const classidIsTab   = urlClassid != null && knownNavTabs.has(urlClassid);
  const effectiveSection  = urlSection  ?? (classidIsTab ? location.pathname.split('/').find(p => p in urlSectionMap) : null);
  const effectiveTab      = classidIsTab ? urlClassid : urlTab;
  const effectiveClassid  = classidIsTab ? null : urlClassid;

  useEffect(() => {
    if (!user) return;
    if (effectiveClassid) return;
    if (!effectiveSection) {
      setdashboard(location.state?.goTo ?? 0);
      return;
    }
    const config = urlSectionMap[effectiveSection];
    if (!config) return;

    if (effectiveTab === 'courses' || urlCourseSlug) {
      setdashboard(102);
      setActiveIndex(config.activeIndex);
      setTestType(config.type);
      setSelectedTypes([config.select]);
      return;
    }

    const offset = effectiveTab ? (tabOffset[effectiveTab] ?? 0) : 0;
    const targetPath = config.mainPath + offset;

    setdashboard(location.state?.goTo ?? targetPath);
    setActiveIndex(config.activeIndex);
    setTestType(config.type);
    setSelectedTypes([config.select]);
    axios.post(`${BASELINE}conversations`, { user_id: user.u_id, chat_type: config.type })
      .then(({ data }) => setid(data.conversation_id))
      .catch(console.error);
  }, [effectiveSection, effectiveTab, effectiveClassid, user]);

  const handleDelete = async (testid) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this test?");
    if (!confirmDelete) return;

    try {
      await axios.delete(`${BASELINE}autosave/${testid}`, { params: { userid: user.u_id } });

      // Update the autosave state instead of testResults
      setAutosave(prevAutosave =>
        prevAutosave.filter((test) => test.testid !== testid)
      );

      // If the currently selected test is deleted, clear the selection
      if (selectedTest?.testid === testid) {
        setSelectedTest(null);
      }
      toast.success('Test deleted successfully!');
    } catch (error) {
      alert('Something went wrong when deleting.');
      console.error(error);
    }
  };

  const preprocessOptions = (optionsString) => {
    try {
      // Now try to parse the JSON
      return JSON.parse(optionsString);
    } catch (e) {
      console.error("Failed to parse options:", e);
      return []; // Fallback to an empty array if parsing fails
    }
  };

  const RenderOptions = () => {
    try {
      var options;
      if (selectedTopic.options) {
        options = preprocessOptions(selectedTopic.options); // Process options
      }
      if (typeof options === "string") {
        try {
          options = JSON.parse(options); // Attempt to parse if it's still a string
        } catch (e) {
          console.error("Failed to parse options:", e);
          console.error("Problematic JSON:", options);
          options = []; // Fallback to an empty array if parsing fails
        }
      }

      // If options is an array, map over it
      return options.length > 0 ? (
        options.map((option, idx) => (
          <Option2
            sat={selectedTopic.subject}
            key={idx}
            currentQuestion={selectedTopic}
            option={option}
          />
        ))
      ) : (
        <p>No options available</p> // Fallback if the options array is empty
      );
    } catch (error) {
      //  console.error("Error parsing options:", error);
      return null; // Return nothing if there is an error
    }
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = (testid) => {
    if (testName.length > 3) {
      axios.post(BASELINE + 'tests/title', { testid, testName })
        .then(function (response) {
          setIsEditing(false);
          setSelectedTest((prevState) => ({
            ...prevState,
            test_name: testName,
          }));

          // Update testResults with the new name
          setTestResults((prevTestResults) =>
            prevTestResults.map((test) =>
              test.test_id === testid ? { ...test, test_name: testName } : test
            )
          );
        })
        .catch(function (error) {
          alert("Something went wrong.");
        });
    } else {
      alert("Test name must be more than three letters.");
    }
  };

  const handleInputChange = (e) => {
    setTestName(e.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = () => {
    if (password.length < 6) {
      alert("Password must be at least 6 characters long.");
      return;
    }

    axios.post(BASELINE + 'user/setpassword', [user.u_id, password])
      .then(function (response) {
        setPassword('');
        alert("Password Reset Successfully!");
      })
      .catch(function (error) {
        alert("Something Went Wrong.");
      });

    setIsOpen(false);
  };

  function logout() {
    logoutUser();
    axios.post(BASELINE + 'user/logout', {})
      .catch(function (error) {
        toast.error('Logout error: ' + error.message);
      })
      .finally(function () {
        window.location.replace(AFTER_LOGIN);
      });
  }

  const tabs = [
    { id: 'all', title: 'All Questions' },
    { id: 'readingWriting', title: 'Reading and Writing' },
    { id: 'math', title: 'Math' },
  ];

  const tabs2 = [
    { id: 'all', title: 'All Questions' },
  ];

  const tabs3 = [
    { id: 'all', title: 'All Questions' },
    { id: 'english', title: 'English' },
    { id: 'math', title: 'Math' },
    { id: 'reading', title: 'Reading' },
    { id: 'science', title: 'Science' },
  ];

  const tabs4 = [
    { id: 'all', title: 'All Questions' },
    { id: 'mcq', title: 'Multiple Choice' },
    { id: 'frq', title: 'Free Response' },
  ];

  const getInitialData2 = () => ({
    labels: ["Target Score"],
    datasets: [
      {
        // label: 'Target Score', // 굳이 label이 필요 없다면 제거
        data: [maxScore],
        backgroundColor: "rgba(201, 203, 207, 0.6)",
        borderColor: "rgba(107, 114, 128, 1)", // 어두운 그레이 계열
        borderWidth: 1,
        borderRadius: 8,         // 둥근 모서리
        borderSkipped: false,    // 모든 모서리에 radius 적용
      }
    ]
  });
  const [data2, setData2] = useState(getInitialData2());

  const resetData2 = () => {
    setData2(getInitialData2());
  };

  const options = {
    indexAxis: 'y',
    scales: {
      x: {
        max: maxScore,
        beginAtZero: true,
        ticks: {
          color: '#FFFFFF', // X축 라벨 흰색
        },

      },
      y: {
        ticks: {
          color: '#FFFFFF', // Y축 라벨 흰색
        },

      },
    },
    plugins: {
      legend: {
        labels: {
          color: '#FFFFFF', // 범례 텍스트 흰색
        },
      },
    },
  };

  const data = {
    labels: [''],
    datasets: [
      {
        label: 'Predicted Score',
        data: [percentage],
        backgroundColor: 'rgb(107, 164, 255)',
        borderRadius: {
          topLeft: 0,
          bottomLeft: 0,
          topRight: 6,
          bottomRight: 6
        },
        barThickness: 20,
      },
      {
        label: 'Target Score',
        data: [maxScore],
        backgroundColor: 'rgba(201, 203, 207, 0.6)',
        borderRadius: {
          topLeft: 0,
          bottomLeft: 0,
          topRight: 6,
          bottomRight: 6
        },
        barThickness: 20,
      },
    ],
  };

  const options2 = {
    indexAxis: "y", // 수평 막대
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false // 범례 숨기기 (Target Score label 제거)
      }
    },
    scales: {
      x: {
        max: maxScore,
        beginAtZero: true,
        grid: {
          display: false // X축 grid 제거
        }
      },
      y: {
        grid: {
          display: false // Y축 grid 제거
        }
      }
    }
  };

  const options3 = {
    indexAxis: 'y',
    scales: {
      x: {
        max: 5,
        beginAtZero: true,
      },
    },
  };

  const data3 = {
    labels: [''],
    datasets: [
      {
        label: 'Predicted Score',
        data: [percentage],
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
      },
      {
        label: 'Target Score',
        data: [5],
        backgroundColor: 'rgba(201, 203, 207, 0.6)',
      },
    ],
  };

  const setPage = (newPage) => {
    if (newPage < 0 || newPage >= pageCount) return;
    setCurrentPage(newPage);
  };

  useEffect(() => {
    // Dynamically load the KaTeX script
    const script2 = document.createElement('script');
    script2.src = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js';
    script2.integrity = 'sha384-+VBxd3r6XgURycqtZ117nYw44OOcIax56Z4dCRWbxyPt0Koah1uHoK0o4+/RRE05';
    script2.crossOrigin = 'anonymous';

    // Handle script load
    script2.onload = () => {
      if (boxItemLeftRef.current) {
        const options = {
          delimiters: [
            { left: '$$', right: '$$', display: false },
            { left: "$", right: "$", display: false },
            { left: '\\(', right: '\\)', display: false },
            { left: '\\[', right: '\\]', display: true },
            { left: '\\begin{array}', right: '\\end{array}', display: true }
          ],
          throwOnError: false,
        };

        window.renderMathInElement(boxItemLeftRef.current, options);
      }
    };
    document.body.appendChild(script2);

    // Cleanup: remove the script when component unmounts
    return () => {
      document.body.removeChild(script2);
    };
  }, [selectedTest, selectedTopic, hideExplanation]);

  const handleNextQuestion = () => {
    const nextIndex = index + 1;
    if (nextIndex < overview.length) {
      setindex(nextIndex);
      setSelectedTopic(overview[nextIndex]);
      if (overview[nextIndex].type === 'ACT') {
        setQuestionid(overview[nextIndex].qid);
        settype(overview[nextIndex].type);
      } else if (
        overview[nextIndex].type === 'apcalcab' ||
        overview[nextIndex].type === 'AP_Calc_AB' ||
        overview[nextIndex].type === 'AP_Calc_BC' ||
        overview[nextIndex].type === 'apcalcbc'
      ) {
        setQuestionid(overview[nextIndex].question_id);
        settype(overview[nextIndex].type);
      } else {
        setQuestionid(overview[nextIndex].questionIds);
        settype(overview[nextIndex].type);
      }
    }
  };

  const normalizeLatexBackslashes = (latexString) => {
    if (!latexString) return '';

    // 먼저, 입력이 JSON 문자열인 경우 처리
    let content = latexString;
    try {
      if (typeof latexString === 'string' && latexString.startsWith('[') && latexString.endsWith(']')) {
        content = JSON.parse(latexString);
      }
    } catch (error) {
      console.error("Error parsing JSON string:", error);
    }

    // 단일 문자열에 대해 백슬래시 정규화 수행
    function normalizeString(str) {
      if (!str) return '';

      // 1. 문자열 내의 "\n" (문자열 "\n"이 있는 경우)을 실제 개행 문자로 변환
      str = str.replace(/\\n/g, '\n');

      // 2. 2개 이상의 백슬래시를 단일 백슬래시로 변환
      //    예를 들어, "\\\\(" -> "\(" 로 변환하여 KaTeX 구분자가 올바르게 인식되도록 함.
      return str.replace(/\\{2,}/g, '\\');
    }

    // 배열 및 중첩 배열에 대해서도 처리
    if (Array.isArray(content)) {
      return content.map(item => {
        if (Array.isArray(item)) {
          return item.map(subItem => normalizeString(subItem));
        }
        return normalizeString(item);
      });
    }

    return normalizeString(content);
  };

  const StepByStepSolution = ({ steps }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [showAll, setShowAll] = useState(false);
    const stepContainerRef = useRef(null);
    const [scriptLoaded, setScriptLoaded] = useState(false);

    // Parse steps (if steps is a JSON string)
    const parsedSteps = useMemo(() => {
      try {
        let parsed = typeof steps === 'string' ? JSON.parse(steps) : steps;

        // Apply normalization to each step
        if (Array.isArray(parsed)) {
          return parsed.map(step => normalizeLatexBackslashes(step));
        }

        return normalizeLatexBackslashes(parsed);
      } catch (error) {
        console.error("Error parsing steps:", error);
        return [];
      }
    }, [steps]);

    // Dynamically load the KaTeX auto-render script if not already loaded
    useEffect(() => {
      if (window.renderMathInElement) {
        setScriptLoaded(true);
        return;
      }
      const script = document.createElement("script");
      script.src =
        "https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js";
      script.integrity =
        "sha384-+VBxd3r6XgURycqtZ117nYw44OOcIax56Z4dCRWbxyPt0Koah1uHoK0o4+/RRE05";
      script.crossOrigin = "anonymous";
      script.onload = () => setScriptLoaded(true);
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }, []);

    // Function to render math using KaTeX on the step container
    const renderMath = useCallback(() => {
      if (scriptLoaded && window.renderMathInElement && stepContainerRef.current) {
        const options = {
          delimiters: [
            { left: "$$", right: "$$", display: true },
            { left: "$", right: "$", display: false },
            { left: "\\(", right: "\\)", display: false },
            { left: "\\[", right: "\\]", display: true },
            { left: "\\begin{array}", right: "\\end{array}", display: true },
          ],
          throwOnError: false,
        };
        window.renderMathInElement(stepContainerRef.current, options);
      }
    }, [scriptLoaded]);

    // Re-render math each time the step changes or when toggling the view mode.
    useLayoutEffect(() => {
      renderMath();
    }, [currentStep, showAll, parsedSteps, renderMath]);

    const handleNext = () => {
      if (currentStep < parsedSteps.length - 1) {
        setCurrentStep(currentStep + 1);
      }
    };

    const handlePrevious = () => {
      if (currentStep > 0) {
        setCurrentStep(currentStep - 1);
      }
    };

    const toggleShowAll = () => {
      setShowAll(!showAll);
    };

    return (
      <div className="mt-4 p-4 bg-white rounded-lg shadow" ref={stepContainerRef}>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-gray-800">Solution Steps</h3>
          <div className="flex space-x-2">
            <button
              onClick={toggleShowAll}
              className="px-3 py-1 bg-[#5c8dff] text-white rounded hover:bg-[#4a7aef] transition-colors"
            >
              {showAll ? "Show Step by Step" : "Show All Steps"}
            </button>
          </div>
        </div>
        {showAll ? (
          <div className="space-y-4">
            {parsedSteps.map((step, index) => (
              <div key={index} className="p-3 border border-gray-200 rounded bg-gray-50">
                <div className="flex items-start">
                  <span className="bg-[#5c8dff] text-white rounded-full w-6 h-6 flex items-center justify-center mr-3">
                    {index + 1}
                  </span>
                  <div
                    dangerouslySetInnerHTML={{ __html: step }}
                    className="text-gray-800 overflow-x-auto"
                  />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="mb-4">
            <div className="relative py-3 px-5 border border-gray-200 rounded bg-gray-50 min-h-[200px]">
              <div className="absolute top-2 right-2 text-gray-500 text-sm">
                Step {currentStep + 1} of {parsedSteps.length}
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: parsedSteps[currentStep] }}
                className="mt-6 text-gray-800 overflow-x-auto"
              />
            </div>
            <div className="flex justify-between mt-4">
              <button
                onClick={handlePrevious}
                disabled={currentStep === 0}
                className={`px-3 py-1 rounded transition-colors ${currentStep === 0
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-[#333333] text-white hover:bg-[#444444]"
                  }`}
              >
                Previous
              </button>
              <button
                onClick={handleNext}
                disabled={currentStep === parsedSteps.length - 1}
                className={`px-3 py-1 rounded transition-colors ${currentStep === parsedSteps.length - 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-[#5c8dff] text-white hover:bg-[#4a7aef]"
                  }`}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderRationale = (selectedTopic) => {
    // For AP Calculus AB, use step_by_step content if available
    if (
      (selectedTest?.type === "AP_Calc_AB" ||
        selectedTest?.type === "apcalcab" || selectedTest?.type === "AP_Calc_BC") &&
      selectedTopic.step_by_step
    ) {
      return (
        <StepByStepSolution
          steps={selectedTopic.step_by_step}
          boxItemLeftRef={boxItemLeftRef}
        />
      );
    }

    let content = selectedTopic.rationale2 || selectedTopic.rationale;

    if (!content) {
      return null;
    }

    // If content is not an array (i.e. not JSON), render it directly
    if (content[0] !== "[") {
      return (
        <div
          dangerouslySetInnerHTML={{ __html: content }}
          className="ml-[20px] mr-[20px] scrollbar-hide overflow-y-auto overflow-x-hidden mt-[10px]"
        />
      );
    }

    // Otherwise, try parsing as JSON and render accordingly
    try {
      content = JSON.parse(content);

      return content.map((item, index) => {
        if (Array.isArray(item)) {
          return (
            <div key={index} className="mb-4">
              {item.map((subItem, subIndex) => (
                <div
                  key={`${index}-${subIndex}`}
                  dangerouslySetInnerHTML={{ __html: subItem }}
                  className="ml-[20px] mr-[20px] max-h-[500px] overflow-y-auto overflow-x-hidden mt-[10px]"
                />
              ))}
            </div>
          );
        }
        return (
          <div
            key={index}
            dangerouslySetInnerHTML={{ __html: item }}
            className="ml-[20px] mr-[20px] max-h-[500px] overflow-y-auto overflow-x-hidden mt-[10px]"
          />
        );
      });
    } catch (error) {
      console.error("Error parsing content:", error);
      return (
        <div
          dangerouslySetInnerHTML={{ __html: content }}
          className="ml-[20px] mr-[20px] scrollbar-hide overflow-y-auto overflow-x-hidden mt-[10px]"
        />
      );
    }
  };

  const handlePreviousQuestion = () => {
    const prevIndex = index - 1;
    if (prevIndex >= 0) {
      setindex(prevIndex);
      setSelectedTopic(overview[prevIndex]);
      if (overview[prevIndex].type === 'ACT') {
        setQuestionid(overview[prevIndex].qid);
        settype(overview[prevIndex].type);
      } else if (
        overview[prevIndex].type === 'apcalcab' ||
        overview[prevIndex].type === 'AP_Calc_AB' ||
        overview[prevIndex].type === 'AP_Calc_BC' ||
        overview[prevIndex].type === 'apcalcbc'
      ) {
        setQuestionid(overview[prevIndex].question_id);
        settype(overview[prevIndex].type);
      } else {
        setQuestionid(overview[prevIndex].questionIds);
        settype(overview[prevIndex].type);
      }
    }
  };

  const handleButtonClick = async (userpick, questionid, tag, type, data, index, section) => {

    if (section === 'frq') {
      setindex(index);
      if (data.length > 0) { setoverview(data); }
      setQuestionid(questionid);
      settag("Math");
      settype(type);
      getquestion(questionid, type, "Math");
    } else {
      setindex(index);
      if (data.length > 0) { setoverview(data); }
      setPicked(userpick);
      setQuestionid(questionid);

      let section2;
      if (tag === "eng") {
        section2 = "Eng";
      } else {
        section2 = "Math";
      }
      settag(section2);

      if (!type) { settype("SAT") } else { settype(type) }
      getquestion(questionid, type, section2);
    }
  };

  const getquestion = async (questionid, type, section) => {

    if (type === "SAT89") {
      if (tag === "eng") {
        section = "eng";
      } else {
        section = "math";
      }

      try {
        let res = await axios.get(BASELINE + "questions/sat89", { params: { id: [questionid], section: section } });
        let arr = [res.data];
        let mappedQuestions = arr[0].map((question, idx) => {
          return { ...question, index: idx, answered: false, bookMarked: false, crossedOutOptions: [], selectedOption: null };
        });

        if (mappedQuestions[0].stimulus) {
          settag("Eng");
        } else {
          settag("Math");
        }

        setSelectedTopic(mappedQuestions[0]);
      } catch (error) {
        toast.error(error.message);
        console.error(error);
      }
    } else if (type === "SAT10") {
      if (tag === "eng") {
        section = "eng";
      } else {
        section = "math";
      }

      try {
        let res = await axios.get(BASELINE + "questions/sat10", { params: { id: [questionid], section: section } });
        let arr = [res.data];
        let mappedQuestions = arr[0].map((question, idx) => {
          return { ...question, index: idx, answered: false, bookMarked: false, crossedOutOptions: [], selectedOption: null };
        });

        if (mappedQuestions[0].stimulus) {
          settag("Eng");
        } else {
          settag("Math");
        }

        setSelectedTopic(mappedQuestions[0]);
      } catch (error) {
        toast.error(error.message);
        console.error(error);
      }
    } else if (type === "SAT") {
      try {
        let res = await axios.get(BASELINE + "questions/sat", { params: { id: [questionid], section: section } });
        let arr = [res.data];
        let mappedQuestions = arr[0].map((question, idx) => {
          return { ...question, index: idx, answered: false, bookMarked: false, crossedOutOptions: [], selectedOption: null };
        });

        if (mappedQuestions[0].stimulus) {
          settag("Eng");
        } else {
          settag("Math");
        }

        setSelectedTopic(mappedQuestions[0]);
      } catch (error) {
        toast.error(error.message);
        console.error(error);
      }
    } else if (type === 'ACT') {
      try {
        let res = await axios.get(BASELINE + "questions/act", { params: { id: questionid } });
        let arr = [res.data];

        let mappedQuestions = arr[0].map((question, idx) => {
          return { ...question, index: idx, answered: false, bookMarked: false, crossedOutOptions: [], selectedOption: null };
        });

        settag("Eng");

        setSelectedTopic(mappedQuestions[0]);
      } catch (error) {
        toast.error(error.message);
        console.error(error);
      }
    } else if (type === "AP_Calc_AB" || type === "apcalcab" || type === "AP_Calc_BC") {
      try {
        let res = await axios.get(BASELINE + "questions/ap", { params: { id: [questionid] } });
        let arr = [res.data];
        let mappedQuestions = arr[0].map((question, idx) => {
          return { ...question, index: idx, answered: false, bookMarked: false, crossedOutOptions: [], selectedOption: null };
        });

        setoptions(JSON.parse(arr[0][0].options));

        if (mappedQuestions[0].stimulus) {
          settag("Eng");
        } else {
          settag("Math");
        }

        setSelectedTopic(mappedQuestions[0]);
      } catch (error) {
        toast.error(error.message);
        console.error(error);
      }
    }

    setIsModalOpen(true);
  };

  useEffect(() => {
    setoptions([]);
    if (questionid && type) {
      getquestion(questionid, type, tag);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionid, tag, type]);


  useEffect(() => {
    if (selectedTest !== null) {
      if (selectedTest.section_data !== null) {
        if (selectedTest?.type === 'SAT' || selectedTest?.type === 'SAT10' || selectedTest?.type === 'SAT89') {
          setPercentage(parseInt(selectedTest.eng_score, 10) + parseInt(selectedTest.math_score, 10));
          let sat = JSON.parse(selectedTest.section_data);

          let eng = sat.filter(s => s.tag === 'eng');
          let math = sat.filter(s => s.tag === 'math');
          setengtag(eng);
          setmathtag(math);

          let grouped = sat.reduce((r, a) => {
            r[a.section] = [...r[a.section] || [], a];
            return r;
          }, {});

          let scores = [];

          for (let section in grouped) {
            let maxScore = section.includes('Hard') ? 800 : 600;
            let totalScore = grouped[section].reduce((total, a) => a.correct ? total + 1 : total, 0);
            let score = Math.round(totalScore / grouped[section].length * maxScore);
            scores.push(Math.max(score, 100));
          }

          seteng(scores[0] + scores[1]);
          setmath(scores[2] + scores[3]);

          let incorrectElements = sat.filter(s => !s.correct);
          setMissing_topics([...incorrectElements]);

          let correctCount = sat.reduce((total, a) => a.correct ? total + 1 : total, 0);
          let incorrectCount = sat.length - correctCount;

          set_cans(correctCount);
          set_wans(incorrectCount);
        } else if (selectedTest?.type === 'ACT') {
          let sat = JSON.parse(selectedTest.section_data);

          let eng = sat.filter(s => s.tag === 'english');
          let math = sat.filter(s => s.tag === 'math');
          let reading = sat.filter(s => s.tag === 'reading');
          let science = sat.filter(s => s.tag === 'science');

          setengtag(eng);
          setmathtag(math);
          setreadingtag(reading);
          setsciencetag(science);

          let grouped = sat.reduce((r, a) => {
            r[a.tag] = [...r[a.tag] || [], a];
            return r;
          }, {});

          let scores = [];

          for (let section in grouped) {
            let maxScore = 36;
            let totalScore = grouped[section].reduce((total, a) => a.correct ? total + 1 : total, 0);
            let score = Math.round(totalScore / grouped[section].length * maxScore);
            scores.push(Math.max(score, 100));
          }

          seteng(scores[0] + scores[1]);
          setmath(scores[2] + scores[3]);

          let incorrectElements = sat.filter(s => !s.correct);
          setMissing_topics([...incorrectElements]);

          let correctCount = sat.reduce((total, a) => a.correct ? total + 1 : total, 0);
          let incorrectCount = sat.length - correctCount;

          set_cans(correctCount);
          set_wans(incorrectCount);
        } else if (selectedTest?.type === 'AP_Calc_AB') {
          setPercentage(JSON.parse(selectedTest.eng_score)["APscore"]);
          let sat = JSON.parse(selectedTest.section_data);

          let eng = sat.filter(s => s.section === 'mcq');
          let math = sat.filter(s => s.section === 'frq' || s.section === 'frqa' || s.section === 'frqb');

          setengtag(eng);
          setmathtag(math);

          let incorrectElements = sat.filter(s => !s.correct);
          setMissing_topics([...incorrectElements]);

          let correctCount = sat.reduce((total, a) => a.correct ? total + 1 : total, 0);
          let incorrectCount = sat.length - correctCount;

          set_cans(correctCount);
          set_wans(incorrectCount);
        }
      }
    }
  }, [selectedTest]);

  const handleTestClick = (test) => {
    if (test.type === 'ACT') {
      if (test.eng_score) {
        setactscores(JSON.parse(test.eng_score));
      } else {

      }
    }

    setTestName(test.test_name);
    setSelectedTest(test);
  };

  const closeModal = () => {
    setSelectedTest("");
    setIsModalOpen(false);
  };

  async function handleStartQuiz() {

    let data;

    if (s_uid) {
      data = {
        id: s_uid
      };
    } else {
      data = {
        id: user.u_id
      };
    }

    axios.post(BASELINE + 'testresult/get', data)
      .then(response => {
        setTestResults(response.data);
        let sum = 0;
        let totalEng = 0;
        let totalMath = 0;
        let count = 0;
        let accumulatedIds = [];
        let accumulatedCorrectIds = [];
        let scores = [];      // SAT 점수와 날짜를 저장할 배열 (예: { score, date })
        let engscores = [];   // 영어 점수 배열
        let mathscores = [];  // 수학 점수 배열

        // response.data를 역순으로 순회
        for (let item of response.data.reverse()) {
          if (selectedTypes.includes(item.type)) {
            if (item.eng_score != null && item.math_score != null) {
              const engScore = Number(item.eng_score);
              engscores.push(engScore);
              const mathScore = Number(item.math_score);
              mathscores.push(mathScore);  // mathScore를 저장

              // 개별 SAT 점수 계산
              const individualSAT = engScore + mathScore;
              setlaste(engScore);
              setlastm(mathScore);
              // 점수와 날짜를 객체 형태로 scores 배열에 저장
              scores.push({
                score: individualSAT,
                date: item.date  // 만약 날짜 정보가 item.test.date가 아니라 item.date라면 적절하게 수정하세요.
              });

              // 첫 유효 점수를 기준으로 sum에 할당
              if (sum === 0) {
                sum = individualSAT;
              }
              totalEng += engScore;
              totalMath += mathScore;
              count++;

              let arr = item.Incorrect_questionIds ? JSON.parse(item.Incorrect_questionIds) : [];
              accumulatedIds = accumulatedIds.concat(arr);
              let corrArr = item.Correct_questionIds ? JSON.parse(item.Correct_questionIds) : [];
              accumulatedCorrectIds = accumulatedCorrectIds.concat(corrArr);
            }
          }
        }

        setIncorrect_questionIds(accumulatedIds);
        setCorrect_questionIds(accumulatedCorrectIds);
        // scores 배열을 역순으로 만들어 상태에 저장 (score와 date를 포함한 객체 배열)
        const reversedScores = [...scores].reverse();
        setAllSATScores(reversedScores);
        setallengscores(engscores);
        setallmathscores(mathscores);

        const avg_sat = count > 0 ? parseInt(Math.round((totalEng + totalMath) / count)) : 0;
        const avg_eng = count > 0 ? parseInt(Math.round(totalEng / count)) : 0;
        const avg_math = count > 0 ? parseInt(Math.round(totalMath / count)) : 0;

        setData2(prevData2 => ({
          ...prevData2,
          datasets: [
            ...prevData2.datasets,
            {
              label: 'Latest Score',
              data: [sum],
              backgroundColor: `rgba(51, 65, 85, 1)`,
              borderRadius: 8,  // 둥근 모서리
            },
          ],
        }));

        setLastTest(sum);
        setavg_sat(avg_sat);
        setavg_eng(avg_eng);
        setavg_math(avg_math);
      })
      .catch(error => {
        console.error(error);
      });


    axios.get(BASELINE + 'getautosave', { params: { id: user.u_id } })
      .then(response => {
        setAutosave(response.data.data);
      })
      .catch(error => {
        console.error(error);
      });
  }

  useEffect(() => {
    resetData2();
    if (user) {
      handleStartQuiz();
    }
  }, [user, selectedTypes]);

  useEffect(() => {
    if (user && user.premium === 0 && pageCount > 0) {
      setCurrentPage(pageCount - 1);
    }
  }, [pageCount]);

  const handleNavigate = (parsedData) => {
    console.log(parsedData, parsedData.type.startsWith('AP_Calc_AB TEST'));
    clearLocalStorageExceptUser();
    if (parsedData) {
      localStorage.setItem('currentTest', parsedData.testid);
      if (parsedData.type === 'SAT') {
        navigate(`/sat/quiz`);
      } else if (parsedData.type === 'SAT10') {
        navigate(`/sat/quiz`);
      } else if (parsedData.type === 'SAT89') {
        navigate(`/sat/quiz`);
      } else if (parsedData.type === 'AP_Calc_AB' || parsedData.type === 'AP_Calc_BC') {
        navigate(`/ap/quiz`);
      } else if (parsedData.type === 'ACT') {
        navigate("/act/quiz", { state: { data: parsedData.testid } });
      } else if (parsedData.type.startsWith('AP_Calc_AB TEST')) {
        const match = parsedData.name.match(/\d+$/); // 문자열 끝의 숫자 추출
        if (match) {
          const num = match[0];
          navigate(`/ap/preset/apcalcbc/${num}`);
        }
      } else if (parsedData.type.startsWith('AP_Calc_BC TEST')) {
        const match = parsedData.name.match(/\d+$/); // 문자열 끝의 숫자 추출
        if (match) {
          const num = match[0];
          navigate(`/ap/preset/apcalcbc/${num}`);
        }
      }
      else {
        navigate(`/sat/preset/quiz/${parsedData.type}`);
      }
    }
  };

  const handleNavigatequiz = async (parsedData, quiz_type, testname) => {
    localStorage.setItem("currentTest", parsedData);
    localStorage.setItem("type", quiz_type);
    localStorage.setItem("testname", testname);
    localStorage.setItem("hw", false);

    navigate("/sat/quiz");
  };

  const handleHomeworkClick = async () => {
    try {
      const data = { userid: user.u_id };
      const response = await axios.post(BASELINE + "gethomework", [data]);
      setHomework(response.data.matchedHomeworks);
    } catch (error) {
      console.error(error);
    }
  };

  const isTestComplete = (hwTestId) => {
    return testResults.some((test) => test.ori_id === hwTestId);
  };

  const isTestPending = (hwTestId) => {
    return autosave.some((auto) => auto.original_tid === hwTestId);
  };

  const startHomework = async (testid, type, name) => {
    const foundAuto = autosave.find((auto) => auto.original_tid === testid);
    const test_id = foundAuto?.testid || null;

    if (isTestPending(testid)) {
      const userConfirmed = window.confirm(
        "You already have a saved test. If you continue, we will delete the old progress and start over. Proceed?"
      );
      if (!userConfirmed) {
        return; // user canceled
      }
      // Delete the old autosave from DB before starting a new test
      try {
        await axios.delete(`${BASELINE}autosave/${test_id}`, { params: { userid: user.u_id } });
        // optionally update your local state:
        setAutosave((prev) => prev.filter((a) => a.testid !== test_id));
      } catch (error) {
        console.error("Error deleting old autosave:", error);
        alert("Could not delete old autosave. Please try again later.");
        return;
      }
    }
    // now proceed to start homework
    handleNavigatequiz(testid, type, name);

  };

  const resumeHomework = (testid, type, name) => {
    // 1) Attempt to find the autosave object by original_tid
    const foundAuto = autosave.find((auto) => auto.original_tid === testid);

    // 2) If not found, alert the user (toast) and stop
    if (!foundAuto) {
      toast.error("Error: please re-assign the homework.");
      return;
    }

    // 3) If found, extract the needed IDs
    const test_id = foundAuto.testid;
    const original_id = foundAuto.original_tid;

    // 4) Store items in localStorage
    localStorage.setItem("currentTest", test_id);
    localStorage.setItem("type", type);
    localStorage.setItem("testname", name);
    localStorage.setItem("hw", true);
    localStorage.setItem("original_text", original_id);

    // 5) Navigate to quiz
    navigate("/sat/quiz");
  };

  async function Retake() {
    if (selectedTest?.type === 'SAT') {
      const parsedData = JSON.parse(selectedTest.quiz_data);
      const questionIds = parsedData.map(item => item.questionIds);

      var tag;
      if (JSON.parse(selectedTest.quiz_data)[0].tag === "math") {
        tag = "Math"
      }

      const quizData = {
        questionIds: questionIds,
        tutorModeActive: false,
        timedModeActive: false,
        timeLimit: null,
        tag: tag,
        type: selectedTest?.type,
      };
      clearLocalStorageExceptUser();
      navigate(`/sat/quiz/`, { state: { data: quizData } });
    }
    else if (selectedTest?.type === 'SAT10') {
      const parsedData = JSON.parse(selectedTest.quiz_data);
      const questionIds = parsedData.map(item => item.questionIds);

      let tag;
      if (JSON.parse(selectedTest.quiz_data)[0].tag === "math") {
        tag = "Math"
      }

      const quizData = {
        questionIds: questionIds,
        tutorModeActive: false,
        timedModeActive: false,
        timeLimit: null,
        tag: tag,
        type: selectedTest?.type,
      };
      clearLocalStorageExceptUser();
      navigate(`/sat/quiz/`, { state: { data: quizData } });
    }
    else if (selectedTest?.type === 'SAT89') {
      const parsedData = JSON.parse(selectedTest.quiz_data);
      const questionIds = parsedData.map(item => item.questionIds);

      let tag;
      if (JSON.parse(selectedTest.quiz_data)[0].tag === "math") {
        tag = "Math"
      }

      const quizData = {
        questionIds: questionIds,
        tutorModeActive: false,
        timedModeActive: false,
        timeLimit: null,
        tag: tag,
        type: selectedTest?.type,
      };
      clearLocalStorageExceptUser();
      navigate(`/sat/quiz/`, { state: { data: quizData } });
    }
    else if (selectedTest?.type === 'ACT') {
      const parsedData = JSON.parse(selectedTest.quiz_data);
      const questionIds = parsedData.map(item => item.qid);

      let tag = JSON.parse(selectedTest.quiz_data)[0].section;

      const quizData = {
        questionIds: questionIds,
        tutorModeActive: false,
        timedModeActive: false,
        timeLimit: null,
        tag: tag,
        type: selectedTest?.type,
      };
      clearLocalStorageExceptUser();
      navigate(`/act/quiz/`, { state: { data: quizData } });
    }
  }

  async function gethelp() {
    var quizDataArray;
    var questionIdsArray;
    var data;
    if (selectedTest?.type === 'SAT' || selectedTest?.type === 'SAT89' || selectedTest?.type === 'SAT10') {
      quizDataArray = JSON.parse(selectedTest.quiz_data);
      questionIdsArray = quizDataArray.map(item => item.questionIds);

      data = {
        questionidsarr: questionIdsArray,
        student_id: user.u_id,
        type: selectedTest?.type,
        tag: quizDataArray[0].tag,
        test_id: selectedTest.test_id
      };
    }
    else if (selectedTest?.type === 'ACT') {
      quizDataArray = JSON.parse(selectedTest.quiz_data);
      questionIdsArray = quizDataArray.map(item => item.qid);

      data = {
        questionidsarr: questionIdsArray,
        student_id: user.u_id,
        type: selectedTest?.type,
        tag: quizDataArray[0].section,
        test_id: selectedTest.test_id
      };
    }

    if (window.confirm("Are you sure you want to get help?")) {
      axios.post(BASELINE + 'post/question/set', [data])
        .then(response => {
          // Handle different responses based on status codes
          if (response.status === 201) {
            window.alert("If you have an assigned teacher, then the teacher will contact you.");
          } else if (response.status === 409) {
            window.alert("A help request with this test ID already exists.");
          } else {
            window.alert("Unexpected response from the server: " + response.status);
          }
        })
        .catch(error => {
          // Handle errors based on the status code returned from the server
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            const status = error.response.status;
            if (status === 409) {
              window.alert("A help request with this test ID already exists.");
            } else if (status === 500) {
              window.alert("Internal server error. Please try again later.");
            } else {
              window.alert("An error occurred: " + error.response.status);
            }
          } else if (error.request) {
            // The request was made but no response was received
            window.alert("No response from the server. Please check your network connection.");
          } else {
            window.alert("Error: " + error.message);
          }
        });
    } else {
      window.alert("Help request cancelled.");
    }

  }

  async function deletethis() {
    if (window.confirm("Are you sure you want to delete the help request?")) {
      // Only test_id is needed to delete the record
      const data = { test_id: selectedTest.test_id };
      axios
        .delete(BASELINE + 'delete/question', { data: [data] })
        .then((response) => {
          if (response.status === 200) {
            window.alert("Test Result has been deleted.");
            // **여기서 local test list 데이터(testResults)를 업데이트합니다.**
            setTestResults((prevTests) =>
              prevTests.filter((test) => test.test_id !== selectedTest.test_id)
            );
            // 선택된 항목도 초기화 (원한다면)
            setSelectedTest(null);
          } else if (response.status === 404) {
            window.alert("No test found.");
          } else {
            window.alert("Unexpected response from the server: " + response.status);
          }
        })
        .catch((error) => {
          if (error.response) {
            const status = error.response.status;
            if (status === 404) {
              window.alert("No help request found with this test ID.");
            } else if (status === 500) {
              window.alert("Internal server error. Please try again later.");
            } else {
              window.alert("An error occurred: " + error.response.status);
            }
          } else if (error.request) {
            window.alert("No response from the server. Please check your network connection.");
          } else {
            window.alert("Error: " + error.message);
          }
        });
    } else {
      window.alert("Deletion cancelled.");
    }
  }

  const backgroundUrl = "/dashboard/bg.png";

  if (!user) {
    return <Navigate to="/dashboard/login" replace />;
    // 또는 return null;
  }

  if (effectiveClassid) {
    const classSection = location.pathname.split('/')[2] || 'sat';
    const handleTabFromClass = (idx) => {
      setdashboard(idx);
      navigate(`/main/${classSection}`, { state: { goTo: idx } });
    };
    return (
      <div style={{ background: "#eef2f7" }} className="h-screen overflow-hidden flex flex-col">
        <div className="shrink-0">
          <SDM handleHomeworkClick={handleHomeworkClick} activeIndex={activeIndex} setActiveIndex={setActiveIndex} user={user} onLogout={logout} testType={testType} setdashboard={handleTabFromClass} setIsOpen={setIsOpen} dashboard={dashboard} />
        </div>
        <Feedback />
        <div className="flex-1 overflow-hidden">
          <HomeworkView setdashboard={setdashboard} shortid={effectiveClassid} user={user} />
        </div>
      </div>
    );
  }

  return (
    <div style={![0,1,2,3,5,102].includes(dashboard) ? { backgroundImage: `url(${backgroundUrl})` } : { background: "#eef2f7" }} className={`bg-cover bg-center h-screen overflow-hidden flex flex-col`}>
      {loading && <LoadingScreen />}

      <div className="shrink-0">
        <SDM handleHomeworkClick={handleHomeworkClick} activeIndex={activeIndex} setActiveIndex={setActiveIndex} user={user} onLogout={logout} testType={testType} setdashboard={setdashboard} setIsOpen={setIsOpen} dashboard={dashboard} />
      </div>
      <Feedback />
      {isOpen && (
        <div className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div className="inline-block align-bottom bg-gray-100 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-gray-100 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                      Password Reset
                    </h3>
                    <div className="mt-2">
                      <input type="password" value={password} onChange={handlePasswordChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="password" placeholder="New Password" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button type="button" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm" onClick={handleSubmit}>
                  Submit
                </button>
                <button type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-white shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm" onClick={() => setIsOpen(false)}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="flex-1 overflow-hidden relative">
        {/* Content Area */}

        {dashboard === 201 && (
          <div className="mr-[20px]">
            <GetHelp
              studentid={user?.u_id}
            />
          </div>
        )}

        {dashboard === 0 && (
          <div className="h-full overflow-y-auto">
            <MainDashboard
              setdashboard={setdashboard}
              setActiveIndex={setActiveIndex}
              setTestType={setTestType}
              setSelectedTypes={setSelectedTypes}
            />
          </div>
        )}

        {dashboard === 1 && (
          <DigitalSatView
            setActiveIndex={setActiveIndex}
            user={user}
            lastTest={lastTest}
            laste={laste}
            lastm={lastm}
            data2={data2}
            options2={options2}
            setdashboard={setdashboard}
            avg_sat={avg_sat}
            avg_eng={avg_eng}
            avg_math={avg_math}
            Incorrect_questionIds={Incorrect_questionIds}
            Correct_questionIds={Correct_questionIds}
            allSATScores={allSATScores}
            allengscores={allengscores}
            allmathscores={allmathscores}
            setaiquestion={setaiquestion}
            setmocksatreview={setmocksatreview}
            setsatanal={setsatanal}
          />
        )}

        {dashboard === 3 && (
          <div className="h-full overflow-y-auto">
            <RandomSATReady setLoading={setLoading} />
          </div>
        )}

        {dashboard === 2 && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="pb-10"
          >
            {/* Page header */}
            <div className="px-4 lg:px-[150px] pt-8 pb-2">
              <h1 className="text-2xl font-bold text-slate-900">Digital SAT Scores</h1>
              {/* Blue accent divider */}
              <div className="mt-4 h-px bg-gradient-to-r from-blue-500/40 via-blue-300/20 to-transparent" />
            </div>

            <div className="container mx-auto px-4 lg:px-[150px]">
              <TestList
                setdashboard={setdashboard}
                currentTests={currentTests}
                handleTestClick={handleTestClick}
                selectedTest={selectedTest}
              />

              {user && user.premium === 1 && (
                <Pagination currentPage={currentPage} pageCount={pageCount} setPage={setPage} light />
              )}
            </div>
          </motion.div>
        )}


        {dashboard === 5 && smallmode !== true && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="h-full overflow-y-auto"
            style={{ background: "#eef2f7" }}
          >
            <div className="max-w-6xl mx-auto px-8 py-6">
              {/* Header */}
              <div className="flex items-center gap-3 mb-6">
                <h1 className="text-xl font-bold text-slate-900">Resume Test</h1>
                <div className="flex-1 h-px bg-slate-300/60" />
                {autosave?.length > 0 && (
                  <span className="text-xs font-semibold text-slate-500 bg-white border border-slate-200 px-3 py-1 rounded-full">
                    {autosave.length} saved
                  </span>
                )}
              </div>

              {autosave?.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {autosave.map((test, index) => {
                    const dateObj = new Date(test.created_date);
                    const formatted = `${dateObj.getFullYear()}-${String(dateObj.getMonth()+1).padStart(2,'0')}-${String(dateObj.getDate()).padStart(2,'0')}`;

                    const getTypeInfo = (t) => {
                      if (t === "ACT")                        return { label: "ACT",        cls: "bg-orange-50 text-orange-700 border-orange-200",  accent: "#f97316" };
                      if (t === "AP_Calc_AB" || t === "AP_Calc_AB TEST") return { label: "AP Calc AB", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", accent: "#059669" };
                      if (t === "AP_Calc_BC" || t === "AP_Calc_BC TEST") return { label: "AP Calc BC", cls: "bg-teal-50 text-teal-700 border-teal-200",       accent: "#0d9488" };
                      if (t === "SAT89" || t.slice(0,3) === "p89")       return { label: "SAT 8/9",    cls: "bg-violet-50 text-violet-700 border-violet-200",  accent: "#7c3aed" };
                      if (t === "SAT10" || t.slice(0,3) === "p10")       return { label: "NMSQT",      cls: "bg-indigo-50 text-indigo-700 border-indigo-200",  accent: "#4338ca" };
                      return                                              { label: "SAT",       cls: "bg-blue-50 text-blue-700 border-blue-200",      accent: "#2563eb" };
                    };
                    const typeInfo = getTypeInfo(test.type);
                    const isHW = test.original_tid?.length > 2;

                    return (
                      <div
                        key={index}
                        className="bg-white border border-slate-200 rounded-xl shadow-sm flex flex-col hover:shadow-md transition-shadow duration-200 overflow-hidden"
                      >
                        {/* Top accent */}
                        <div className="h-[3px]" style={{ background: typeInfo.accent }} />

                        {/* Badges */}
                        <div className="px-5 pt-4 flex flex-wrap gap-2">
                          <span className={`text-xs font-semibold px-3 py-1 rounded-full border ${typeInfo.cls}`}>
                            {typeInfo.label}
                          </span>
                          {isHW && (
                            <span className="text-xs font-semibold px-3 py-1 rounded-full border bg-violet-50 text-violet-700 border-violet-200">
                              Homework
                            </span>
                          )}
                        </div>

                        {/* Name */}
                        <div className="px-5 py-4 flex-1">
                          <div className="border-t border-slate-100 pt-4 mt-3">
                            {!isHW && editingTestId === test.testid ? (
                              <div className="flex items-center gap-1.5 bg-slate-50 border border-slate-200 rounded-lg p-2.5">
                                <input
                                  type="text"
                                  value={editedTestName}
                                  onChange={(e) => setEditedTestName(e.target.value)}
                                  className="flex-1 text-slate-800 font-bold text-sm bg-transparent border-b border-blue-400 focus:outline-none px-1 py-0.5"
                                />
                                <button
                                  onClick={() => setEditingTestId(null)}
                                  className="text-slate-400 hover:text-red-500 text-xs transition-colors"
                                >✕</button>
                                <button
                                  onClick={() => handleSaveTestName(test)}
                                  className="text-xs px-2.5 py-1 bg-blue-600 hover:bg-blue-500 text-white rounded-lg transition-colors"
                                >Save</button>
                              </div>
                            ) : (
                              <div className="flex items-center justify-center gap-2">
                                <p className="text-slate-800 font-bold uppercase text-base text-center leading-snug">
                                  {test.name}
                                </p>
                                {!isHW && (
                                  <FaPencilAlt
                                    className="cursor-pointer text-xs text-blue-400 hover:text-blue-600 transition-colors shrink-0"
                                    onClick={() => { setEditingTestId(test.testid); setEditedTestName(test.name); }}
                                  />
                                )}
                              </div>
                            )}
                            <p className="text-center text-slate-400 text-sm mt-2">{formatted}</p>
                          </div>
                        </div>

                        {/* Buttons */}
                        <div className="px-5 pb-5 flex gap-2.5">
                          <button
                            className="flex items-center justify-center w-11 h-11 border border-red-200 bg-red-50 text-red-500 hover:bg-red-100 rounded-lg transition-colors shrink-0"
                            onClick={() => handleDelete(test.testid)}
                          >
                            <BsTrash size={14} />
                          </button>
                          <button
                            className="flex-1 bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold rounded-lg py-2.5 transition-colors shadow-sm"
                            onClick={() => handleNavigate(test)}
                          >
                            Resume →
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center h-64 bg-white border border-slate-200 rounded-xl shadow-sm">
                  <BsFileEarmarkX className="text-5xl text-slate-300 mb-4" />
                  <h2 className="text-base font-semibold text-slate-600">No Saved Tests</h2>
                  <p className="text-slate-400 text-sm mt-1.5 text-center">
                    Start a quiz to save your progress here.
                  </p>
                </div>
              )}
            </div>
          </motion.div>
        )}

        {dashboard === 6 && (
          <DigitalActView
            user={user}
            setdashboard={setdashboard}
          />
        )}

        {dashboard === 7 && (
          <RandomACTReady className="ml-[250px]" setLoading={setLoading} />
        )}

        {dashboard === 8 && (
          <>
            <h1 className="text-2xl font-bold mt-4 pl-6 text-white">View Digital ACT Scores</h1>
            <div className="">
              <TestList
                type={'ACT'}
                currentTests={currentTests}
                handleTestClick={handleTestClick}
                selectedTest={selectedTest}
              />

              {user && user.premium === 1 && (
                <Pagination currentPage={currentPage} pageCount={pageCount} setPage={setPage} />
              )}
            </div>
          </>
        )}

        {dashboard === 9 && (
          <>
            <OverallACTANAL />
          </>
        )}

        {dashboard === 10 && (
          <DigitalNMSQTView
            setActiveIndex={setActiveIndex}
            user={user}
            lastTest={lastTest}
            data2={data2}
            options2={options2}
            setdashboard={setdashboard}
            avg_sat={avg_sat}
            avg_eng={avg_eng}
            avg_math={avg_math}
            Incorrect_questionIds={Incorrect_questionIds}
            allSATScores={allSATScores}
          />
        )}

        {dashboard === 11 && (
          <RandomNMSQTReady className="ml-[250px]" setLoading={setLoading} />
        )}

        {dashboard === 12 && (
          <div className="bg-gray-100">
            <div className="pl-6 pt-6 text-gray-500 text-sm">
              <span className="hover:underline cursor-pointer">My Home</span> &gt; <span className="font-semibold text-black">Report Card</span>
            </div>
            <h1 className="text-2xl font-bold mt-4 pl-6">Digital PSAT NMSQT Scores</h1>
            <div className="bg-gray-100">
              <TestList
                type={'SAT10'}
                currentTests={currentTests}
                handleTestClick={handleTestClick}
                selectedTest={selectedTest}
              />

              {user && user.premium === 1 && (
                <Pagination currentPage={currentPage} pageCount={pageCount} setPage={setPage} />
              )}
            </div>
          </div>
        )}

        {dashboard === 13 && (
          <>
            <OverallNMSQTAnal />
          </>
        )}

        {dashboard === 14 && (
          <DigitalSAT89View
            setActiveIndex={setActiveIndex}
            user={user}
            lastTest={lastTest}
            data2={data2}
            options2={options2}
            setdashboard={setdashboard}
            avg_sat={avg_sat}
            avg_eng={avg_eng}
            avg_math={avg_math}
            Incorrect_questionIds={Incorrect_questionIds}
            allSATScores={allSATScores}
          />
        )}

        {dashboard === 15 && (
          <RandomSAT89Ready className="ml-[250px]" setLoading={setLoading} />
        )}

        {dashboard === 16 && (
          <div className="bg-gray-100">
            <div className="pl-6 pt-6 text-gray-500 text-sm">
              <span className="hover:underline cursor-pointer">My Home</span> &gt; <span className="font-semibold text-black">Report Card</span>
            </div>
            <h1 className="text-2xl font-bold mt-4 pl-6">Digital PSAT 8 & 9 Scores</h1>
            <div className="bg-gray-100">
              <TestList
                type={'SAT89'}
                currentTests={currentTests}
                handleTestClick={handleTestClick}
                selectedTest={selectedTest}
              />

              {user && user.premium === 1 && (
                <Pagination currentPage={currentPage} pageCount={pageCount} setPage={setPage} />
              )}
            </div>
          </div>
        )}

        {dashboard === 17 && (
          <>
            <OverallSAT89Anal />
          </>
        )}

        {dashboard === 18 && (
          <DigitalAPABView
            setActiveIndex={setActiveIndex}
            user={user}
            setdashboard={setdashboard}
          />
        )}

        {dashboard === 19 && (
          <RandomAPCALCABReady className="ml-[250px]" setLoading={setLoading} />
        )}

        {dashboard === 20 && (
          <>
            <h1 className="text-white text-2xl font-bold mt-4 pl-6">Digital AP Calculus AB Scores</h1>
            <div className="">
              <TestList
                currentTests={currentTests}
                handleTestClick={handleTestClick}
                selectedTest={selectedTest}
              />

              {user && user.premium === 1 && (
                <Pagination currentPage={currentPage} pageCount={pageCount} setPage={setPage} />
              )}
            </div>
          </>
        )}

        {dashboard === 21 && (
          <OverallABAnal />
        )}

        {dashboard === 22 && (
          <DigitalAPBCView
            setActiveIndex={setActiveIndex}
            user={user}
            setdashboard={setdashboard}
          />
        )}

        {dashboard === 23 && (
          <RandomAPCALCBCReady className="ml-[250px]" setLoading={setLoading} />
        )}

        {dashboard === 24 && (
          <>
            <h1 className="text-white text-2xl font-bold mt-4 pl-6">View Digital AP Calculus BC History</h1>
            <div className="">
              <TestList
                currentTests={currentTests}
                handleTestClick={handleTestClick}
                selectedTest={selectedTest}
              />

              {user && user.premium === 1 && (
                <Pagination currentPage={currentPage} pageCount={pageCount} setPage={setPage} />
              )}
            </div>
          </>
        )}

        {dashboard === 25 && (
          <OverallBCAnal />
        )}

        {dashboard === 102 && (
          <StudentDashboard setdashboard={setdashboard} setshortid={setshortid} courseSlug={urlCourseSlug} />
        )}
      </div>

      {selectedTest && (
        <motion.div
          className="fixed inset-0 z-[50] flex justify-end"
          initial={{ x: "100%" }}       // Start off-screen to the right
          animate={{ x: 0 }}            // Animate to its natural position
          exit={{ x: "100%" }}          // Slide out to the right when exiting
          transition={{ type: "tween", duration: 0.5 }}  // Adjust the timing as needed
        >

          {/* Backdrop */}
          <div className="fixed inset-0 bg-slate-900/20 backdrop-blur-[2px]" aria-hidden="true" onClick={closeModal} />

          {/* Panel */}
          <div className="relative bg-white p-6 w-full md:w-[42%] h-full overflow-y-auto border-l border-slate-200 shadow-2xl shadow-slate-300/40"
            style={{ scrollbarWidth: 'thin', scrollbarColor: '#e2e8f0 transparent' }}>

            {/* Close button */}
            <button
              className="absolute top-5 right-5 w-8 h-8 flex items-center justify-center rounded-lg bg-slate-100 text-slate-400 hover:bg-slate-200 hover:text-slate-700 transition-all duration-150"
              onClick={closeModal}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {user && selectedTest.ori_id === "" ? (
              <>
                {/* Test name (editable) */}
                <div className="flex items-center gap-2 mb-5 pr-10">
                  {isEditing ? (
                    <>
                      <input
                        type="text"
                        value={testName}
                        onChange={handleInputChange}
                        className="flex-1 px-3 py-1.5 text-slate-800 font-semibold text-base bg-slate-50 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200"
                      />
                      <button
                        onClick={() => handleSaveClick(selectedTest.test_id)}
                        className="text-blue-600 hover:text-blue-700 px-2 py-1 rounded"
                      >
                        <FaSave size={14} />
                      </button>
                    </>
                  ) : (
                    <>
                      <p className="font-semibold text-lg text-slate-800">{selectedTest.test_name}</p>
                      {selectedTest && selectedTest.ori_id === "" && user && user.u_id === selectedTest.user_id && (
                        <button onClick={() => handleEditClick()} className="text-slate-400 hover:text-slate-600 px-1">
                          <RiEditFill size={14} />
                        </button>
                      )}
                    </>
                  )}
                </div>

                {(() => {
                  const correct = JSON.parse(selectedTest.Correct_questionIds || '[]').length;
                  const wrong = JSON.parse(selectedTest.Incorrect_questionIds || '[]').length;
                  const total = correct + wrong;
                  const pct = total > 0 ? Math.round((correct / total) * 100) : 0;
                  return (
                    <div className="mb-5">
                      <div className="flex items-start gap-4 mb-3">
                        <CircleGraph correctQuestions={correct} wrongQuestions={wrong} />
                        <div className="flex-1 flex flex-col gap-2 pt-1">
                          <div className="border border-slate-200 bg-white p-3">
                            <p className="text-xs font-medium text-slate-400 mb-2">Score</p>
                            <div className="flex items-center gap-3">
                              <span className="text-2xl font-bold tabular-nums text-slate-700">{pct}%</span>
                              <div className="flex-1 h-1.5 bg-slate-100 overflow-hidden">
                                <div className="h-full bg-slate-400 transition-all duration-700" style={{ width: `${pct}%` }} />
                              </div>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-2">
                            <div className="border border-slate-200 bg-white p-3">
                              <p className="text-xs font-medium text-slate-400 mb-1">Correct</p>
                              <span className="text-2xl font-bold text-slate-700">{correct}</span>
                            </div>
                            <div className="border border-slate-200 bg-white p-3">
                              <p className="text-xs font-medium text-slate-400 mb-1">Wrong</p>
                              <span className="text-2xl font-bold text-slate-500">{wrong}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      {user?.role !== "teacher" && selectedTest.ori_id === "" && (
                        <button
                          className="w-full py-2.5 text-sm font-medium text-slate-600 bg-slate-100 border border-slate-200 hover:bg-slate-200 transition-all duration-150 flex items-center justify-center gap-2"
                          onClick={() => Retake()}
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>
                          Retake the Test
                        </button>
                      )}
                    </div>
                  );
                })()}
              </>
            ) : (
              selectedTest.section_data === null && (
                <>
                  <p className="font-semibold text-lg text-slate-800 mb-4 pr-10">{selectedTest.test_name}</p>

                  {(() => {
                    const correct = JSON.parse(selectedTest.Correct_questionIds || '[]').length;
                    const wrong = JSON.parse(selectedTest.Incorrect_questionIds || '[]').length;
                    const total = correct + wrong;
                    const pct = total > 0 ? Math.round((correct / total) * 100) : 0;
                    return (
                      <div className="mb-5">
                        <div className="flex items-start gap-4">
                          <CircleGraph correctQuestions={correct} wrongQuestions={wrong} />
                          <div className="flex-1 flex flex-col gap-2 pt-1">
                            <div className="border border-slate-200 bg-white p-3">
                              <p className="text-xs font-medium text-slate-400 mb-2">Score</p>
                              <div className="flex items-center gap-3">
                                <span className="text-2xl font-bold tabular-nums text-slate-700">{pct}%</span>
                                <div className="flex-1 h-1.5 bg-slate-100 overflow-hidden">
                                  <div className="h-full bg-slate-400 transition-all duration-700" style={{ width: `${pct}%` }} />
                                </div>
                              </div>
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                              <div className="border border-slate-200 bg-white p-3">
                                <p className="text-xs font-medium text-slate-400 mb-1">Correct</p>
                                <span className="text-2xl font-bold text-slate-700">{correct}</span>
                              </div>
                              <div className="border border-slate-200 bg-white p-3">
                                <p className="text-xs font-medium text-slate-400 mb-1">Wrong</p>
                                <span className="text-2xl font-bold text-slate-500">{wrong}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })()}
                </>
              )
            )}

            {selectedTest.section_data != null && (<>
              {smallmode !== true && (
                <TestDisplayComponent
                  selectedTest={selectedTest}
                  deletethis={deletethis}
                  actscores={actscores}
                />
              )}

              {smallmode === true && (
                <div className="mb-4 mt-4 bg-slate-50 border border-slate-200 p-6 rounded-xl flex flex-col items-center gap-2">
                  <span className="text-[48px] font-bold text-slate-800">
                    {parseInt(selectedTest.eng_score) + parseInt(selectedTest.math_score)} / 1600
                  </span>
                  <span className="bg-blue-100 text-blue-700 text-xs px-3 py-1 rounded-full">English Score: {selectedTest.eng_score}</span>
                  <span className="bg-slate-200 text-slate-700 text-xs px-3 py-1 rounded-full">Math Score: {selectedTest.math_score}</span>
                  <span className="bg-white border border-slate-200 text-slate-600 text-xs px-3 py-1 rounded-full">Date: {selectedTest.date.split('T')[0]}</span>
                </div>
              )}
            </>)}

            {selectedTest.section_data != null && (
              <div className="border border-slate-200 rounded-xl overflow-hidden">
                {/* Tab bar */}
                <div className="bg-slate-50 border-b border-slate-200 px-4 pt-3 pb-0">
                  <ul className="flex gap-0.5 flex-wrap">
                    {(selectedTest?.type === "SAT" || selectedTest?.type === "SAT10" || selectedTest?.type === "SAT89") && (
                      tabs.map((tab) => (
                        <li
                          key={tab.id}
                          className={`px-3 py-2 text-xs font-medium cursor-pointer transition-all duration-150 border-b-2 -mb-px ${
                            activeTab === tab.id
                              ? 'border-blue-500 text-blue-600'
                              : 'border-transparent text-slate-500 hover:text-slate-700'
                          }`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.title}
                        </li>
                      ))
                    )}
                    {(selectedTest?.type === "AP_Calc_AB" || selectedTest?.type === "AP_Calc_BC") && (
                      tabs4.map((tab) => (
                        <li
                          key={tab.id}
                          className={`px-3 py-2 text-xs font-medium cursor-pointer transition-all duration-150 border-b-2 -mb-px ${
                            activeTab === tab.id
                              ? 'border-blue-500 text-blue-600'
                              : 'border-transparent text-slate-500 hover:text-slate-700'
                          }`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.title}
                        </li>
                      ))
                    )}
                    {selectedTest?.type === "ACT" && (
                      tabs3.map((tab) => (
                        <li
                          key={tab.id}
                          className={`px-3 py-2 text-xs font-medium cursor-pointer transition-all duration-150 border-b-2 -mb-px ${
                            activeTab === tab.id
                              ? 'border-blue-500 text-blue-600'
                              : 'border-transparent text-slate-500 hover:text-slate-700'
                          }`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.title}
                        </li>
                      ))
                    )}
                  </ul>
                </div>

                {/* Tab content */}
                <div className="p-4">
                  <TabsSection
                    activeTab={activeTab}
                    selectedTest={selectedTest}
                    engtag={engtag}
                    mathtag={mathtag}
                    readingtag={readingtag}
                    sciencetag={sciencetag}
                    missing_topics={missing_topics}
                    handleButtonClick={handleButtonClick}
                  />
                </div>
              </div>
            )}

            {selectedTest.section_data == null && (
              <QuizResult
                selectedTest={selectedTest}
                handleButtonClick={handleButtonClick}
                deletethis={deletethis}
              />
            )}
          </div>
        </motion.div>
      )
      }

      <div
        className={`
    fixed top-0 left-0 h-full z-[60]
    transform transition-transform duration-300 ease-out
    ${isModalOpen ? 'translate-x-0' : '-translate-x-full'}
    ${expand ? 'w-full' : 'w-full md:w-[59%]'}
  `}
      >
        {tag === 'Eng' && (
          <div
            ref={boxItemLeftRef}
            className={`relative bg-white w-[100%] h-full overflow-auto`}
          >

            <div className="relative bg-gradient-to-r from-[#0d0f1a] via-[#161928] to-[#0d0f1a] border-b border-white/10 shadow-lg shadow-black/40">
              {/* 헤더 내부 컨텐츠 */}
              <div className="flex flex-col md:flex-row items-center justify-center text-white text-[16px] p-2 pl-[20px] pr-4 md:pr-16 space-y-2 md:space-y-0 md:space-x-4">
                {(selectedTest?.type === 'SAT' ||
                  selectedTest?.type === 'SAT10' ||
                  selectedTest?.type === 'SAT89') && (
                    <div className="my-2 sm:my-0 flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-4 w-full">
                      {/* 제목을 중앙 정렬하고, 모바일에서는 전체 너비를 사용 */}
                      <div className="w-full md:w-auto text-center">Reading and Writing</div>
                      {/* 좌우 버튼 그룹 */}
                      <div className="hidden md:flex items-center justify-center gap-2">
                        <button
                          className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                          onClick={handlePreviousQuestion}>
                          &lt; Left
                        </button>
                        <button
                          className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                          onClick={handleNextQuestion}>
                          Right &gt;
                        </button>
                      </div>

                      <label className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm cursor-pointer">
                        <input
                          type="checkbox"
                          checked={hideExplanation}
                          onChange={handleChange}
                          className="form-checkbox h-5 w-5 text-gray-600 mr-[5px]"
                        />
                        <span>Hide Answer</span>
                      </label>
                    </div>
                  )}

                {selectedTest?.type === 'ACT' && (
                  <div className="flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-4 w-full">
                    <div className="text-[24px] font-bold text-white text-center">
                      {selectedTopic?.subject?.charAt(0).toUpperCase() +
                        selectedTopic?.subject?.slice(1)}
                    </div>
                    <div className="flex items-center justify-center gap-2">
                      <button
                        className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                        onClick={handlePreviousQuestion}
                      >
                        &lt; Left
                      </button>
                      <button
                        className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                        onClick={handleNextQuestion}
                      >
                        Right &gt;
                      </button>
                    </div>
                  </div>
                )}

                {(selectedTest?.type === 'AP_Calc_AB' || selectedTest?.type === 'apcalcab' || selectedTest?.type === 'AP_Calc_BC' || selectedTest?.type === 'apcalcbc') && (
                  <div className=" flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-4 w-full">
                    <div className="text-[24px] font-bold text-white text-center">
                      {(selectedTest?.type === 'AP_Calc_BC' || selectedTest?.type === 'apcalcbc')
                        ? "AP Calculus BC"
                        : "AP Calculus AB"}
                    </div>
                    <div className="hidden md:flex items-center justify-center gap-2">
                      <button
                        className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                        onClick={handlePreviousQuestion}
                      >
                        &lt; Left
                      </button>
                      <button
                        className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                        onClick={handleNextQuestion}
                      >
                        Right &gt;
                      </button>
                    </div>

                    <label className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm cursor-pointer">
                      <input
                        type="checkbox"
                        checked={hideExplanation}
                        onChange={handleChange}
                        className="form-checkbox h-5 w-5 text-gray-600 mr-[5px]"
                      />
                      <span>Hide Answer</span>
                    </label>
                  </div>
                )}
              </div>

              {/* 우측에 절대 위치한 expand 및 닫기 버튼 */}
              <div className="absolute top-2 right-2 flex items-center space-x-2">
                {expand ? (
                  <FaAnglesLeft
                    className="hidden md:block text-[20px] cursor-pointer text-white"
                    onClick={() => setexpand(!expand)}
                  />
                ) : (
                  <FaAnglesRight
                    className="hidden md:block text-[20px] cursor-pointer text-white"
                    onClick={() => setexpand(!expand)}
                  />
                )}

                <button className="p-1.5 rounded-lg bg-white/10 hover:bg-white/25 border border-white/15 transition-all duration-200" onClick={() => setIsModalOpen(false)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="h-6 w-6 text-white"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="flex flex-col md:flex-row mt-[20px] mb-[100px] sm:mb-[0px]">

              <div className="fixed bottom-[30px] left-0 right-0 flex justify-center z-50 block md:hidden">
                <div className="flex items-center justify-center space-x-4 bg-[#1a1a1a] p-3 rounded-full shadow-md border border-gray-600">
                  {/* 왼쪽 화살표 버튼 */}
                  <button
                    className="text-white text-xl font-bold"
                    onClick={handlePreviousQuestion}
                  >
                    &lt;
                  </button>

                  <label className="flex items-center justify-center space-x-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={hideExplanation}
                      onChange={handleChange}
                      className="form-checkbox h-5 w-5 text-gray-600"
                    />
                    <span className="text-white font-semibold">Hide Answer</span>
                  </label>

                  {/* 오른쪽 화살표 버튼 */}
                  <button
                    className="text-white text-xl font-bold"
                    onClick={handleNextQuestion}
                  >
                    &gt;
                  </button>
                </div>
              </div>

              <div className="md:w-1/2 w-full mt-5 pb-4 md:pb-0 border-b-2 md:border-b-0 md:border-r-2 border-indigo-100 md:pr-2">
                {selectedTest?.type === 'ACT' && (
                  selectedTopic?.subject === 'math' ? (
                    <div dangerouslySetInnerHTML={{ __html: selectedTopic?.prompt }} className="ml-[20px]" />
                  ) : (
                    <div dangerouslySetInnerHTML={{ __html: selectedTopic?.content }} className="ml-[20px]" />
                  )
                )}

                {(selectedTest?.type === 'SAT' || selectedTest?.type === 'SAT10' || selectedTest?.type === 'SAT89') && (
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: selectedTopic.stimulus }} className="mb-[50px] sm:mb-0 max-h-[500px] overflow-y-auto overflow-x-hidden ml-5 mr-5 mt-2.5 scrollbar-thin scrollbar-thumb-indigo-200 scrollbar-track-transparent scrollbar-thumb-rounded-full hover:scrollbar-thumb-indigo-300" />
                  </div>
                )}
              </div>

              <div className="md:w-1/2 w-full md:ml-[20px] md:mr-[20px]">
                <div className="mt-4 mb-4 ml-0 md:ml-5">
                  <h2 className="text-xl font-bold bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 bg-clip-text text-transparent text-center md:text-left tracking-tight">
                    Question Review
                  </h2>
                  <div className="mt-1 h-0.5 w-16 bg-gradient-to-r from-blue-400 to-indigo-400 rounded-full mx-auto md:mx-0" />
                </div>

                <div className="my-2 max-w-[560px] overflow-y-auto">
                  {(selectedTest?.type === 'SAT' || selectedTest?.type === 'SAT10' || selectedTest?.type === 'SAT89') && (
                    <div dangerouslySetInnerHTML={{ __html: selectedTopic.stem }} className="ml-[20px]" />
                  )}

                  {selectedTest?.type === 'ACT' && (
                    <div dangerouslySetInnerHTML={{ __html: selectedTopic?.prompt }} className="ml-[20px]" />
                  )}

                  {(selectedTest?.type === 'SAT' || selectedTest?.type === 'SAT10' || selectedTest?.type === 'SAT89') && (
                    <>
                      <Option idx={0} data={selectedTopic.a} />
                      <Option idx={1} data={selectedTopic.b} />
                      <Option idx={2} data={selectedTopic.c} />
                      <Option idx={3} data={selectedTopic.d} />
                    </>
                  )}

                  {selectedTest?.type === 'ACT' && <RenderOptions />}
                </div>

                {picked && selectedTopic?.correct_answer && (() => {
                  const userPicked = picked.charAt(0).toUpperCase() + picked.slice(1);
                  const correctAns = selectedTopic.correct_answer.slice(2, -2);
                  const isCorrect = userPicked.toUpperCase() === correctAns.toUpperCase();
                  return (
                    <div className={`mx-5 my-3 flex items-center gap-3 rounded-xl px-4 py-3 border ${isCorrect ? 'bg-emerald-50 border-emerald-200' : 'bg-rose-50 border-rose-200'}`}>
                      <span className={`text-lg font-bold ${isCorrect ? 'text-emerald-500' : 'text-rose-500'}`}>
                        {isCorrect ? '✓' : '✗'}
                      </span>
                      <div className="text-sm flex items-center gap-1.5 flex-wrap">
                        <span className="text-gray-500">Your answer:</span>
                        <span className={`font-bold px-2 py-0.5 rounded-md ${isCorrect ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'}`}>{userPicked}</span>
                        {!isCorrect && (
                          <>
                            <span className="text-gray-300">·</span>
                            <span className="text-gray-500">Correct:</span>
                            <span className="font-bold px-2 py-0.5 rounded-md bg-emerald-100 text-emerald-700">{correctAns}</span>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {selectedTest?.user_time && selectedTopic?.questionIds && (() => {
                  try {
                    const timeMap = typeof selectedTest.user_time === 'string' ? JSON.parse(selectedTest.user_time) : selectedTest.user_time;
                    const secs = timeMap[selectedTopic.questionIds];
                    if (!secs || secs < 1) return null;
                    const m = Math.floor(secs / 60);
                    const s = Math.floor(secs % 60);
                    const formatted = m > 0 ? `${m}m ${s}s` : `${s}s`;
                    return (
                      <div className="mx-5 mb-3 inline-flex items-center gap-1.5 bg-gray-100 border border-gray-200 rounded-full px-3 py-1">
                        <svg className="w-3 h-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span className="text-xs text-gray-400">Time spent:</span>
                        <span className="text-xs font-semibold text-gray-600">{formatted}</span>
                      </div>
                    );
                  } catch { return null; }
                })()}

                {(selectedTest?.type === 'SAT' || selectedTest?.type === 'SAT10' || selectedTest?.type === 'SAT89') && !hideExplanation && (
                  <div className="mt-[20px] mb-[40px] ml-6 mr-6">
                    <div dangerouslySetInnerHTML={{ __html: selectedTopic.rationale2 ? selectedTopic.rationale2 : selectedTopic.rationale }} />
                  </div>
                )}

                {selectedTest?.type === 'ACT' && !hideExplanation && (
                  <div className="mt-[20px]">
                    <div ref={boxItemLeftRef} dangerouslySetInnerHTML={{ __html: selectedTopic?.expl }} />
                  </div>
                )}

              </div>
            </div>
          </div>
        )}

        {tag === 'Math' && (
          <div
            ref={boxItemLeftRef}
            className={`relative bg-white w-[100%] h-full overflow-auto`}
          >

            <div className="relative bg-gradient-to-r from-[#0d0f1a] via-[#161928] to-[#0d0f1a] border-b border-white/10 shadow-lg shadow-black/40">
              {/* 헤더 내부 컨텐츠 */}
              <div className="flex flex-col md:flex-row items-center justify-center text-white text-[16px] p-2 pl-[20px] pr-4 md:pr-16 space-y-2 md:space-y-0 md:space-x-4">
                {(selectedTest?.type === 'SAT' ||
                  selectedTest?.type === 'SAT10' ||
                  selectedTest?.type === 'SAT89') && (
                    <div className="my-2 sm:my-0 flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-4 w-full">
                      {/* 제목을 중앙 정렬하고, 모바일에서는 전체 너비를 사용 */}
                      <div className="w-full md:w-auto text-center">Math</div>
                      {/* 좌우 버튼 그룹 */}
                      <div className="hidden md:flex items-center justify-center gap-2">
                        <button
                          className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                          onClick={handlePreviousQuestion}>
                          &lt; Left
                        </button>
                        <button
                          className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                          onClick={handleNextQuestion}>
                          Right &gt;
                        </button>
                      </div>

                      <label className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm cursor-pointer">
                        <input
                          type="checkbox"
                          checked={hideExplanation}
                          onChange={handleChange}
                          className="form-checkbox h-5 w-5 text-gray-600 mr-[5px]"
                        />
                        <span>Hide Answer</span>
                      </label>
                    </div>
                  )}

                {selectedTest?.type === 'ACT' && (
                  <div className="flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-4 w-full">
                    <div className="text-[24px] font-bold text-white text-center">
                      {selectedTopic?.subject?.charAt(0).toUpperCase() +
                        selectedTopic?.subject?.slice(1)}
                    </div>
                    <div className="flex items-center justify-center gap-2">
                      <button
                        className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                        onClick={handlePreviousQuestion}
                      >
                        &lt; Left
                      </button>
                      <button
                        className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                        onClick={handleNextQuestion}
                      >
                        Right &gt;
                      </button>
                    </div>
                  </div>
                )}

                {(selectedTest?.type === 'AP_Calc_AB' || selectedTest?.type === 'apcalcab' || selectedTest?.type === 'AP_Calc_BC' || selectedTest?.type === 'apcalcbc') && (
                  <div className="flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-4 w-full">
                    <div className="text-[24px] font-bold text-white text-center">
                      {(selectedTest?.type === 'AP_Calc_BC' || selectedTest?.type === 'apcalcbc')
                        ? "AP Calculus BC"
                        : "AP Calculus AB"}
                    </div>
                    <div className="hidden md:flex items-center justify-center gap-2">
                      <button
                        className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                        onClick={handlePreviousQuestion}
                      >
                        &lt; Left
                      </button>
                      <button
                        className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm"
                        onClick={handleNextQuestion}
                      >
                        Right &gt;
                      </button>
                    </div>

                    <label className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium bg-white/10 border border-white/20 text-white/90 hover:bg-white/20 hover:text-white transition-all duration-200 backdrop-blur-sm cursor-pointer">
                      <input
                        type="checkbox"
                        checked={hideExplanation}
                        onChange={handleChange}
                        className="form-checkbox h-5 w-5 text-gray-600 mr-[5px]"
                      />
                      <span>Hide Answer</span>
                    </label>
                  </div>
                )}
              </div>

              {/* 우측에 절대 위치한 expand 및 닫기 버튼 */}
              <div className="absolute top-2 right-2 flex items-center space-x-2">
                {expand ? (
                  <FaAnglesLeft
                    className="hidden md:block text-[20px] cursor-pointer text-white"
                    onClick={() => setexpand(!expand)}
                  />
                ) : (
                  <FaAnglesRight
                    className="hidden md:block text-[20px] cursor-pointer text-white"
                    onClick={() => setexpand(!expand)}
                  />
                )}

                <button className="p-1.5 rounded-lg bg-white/10 hover:bg-white/25 border border-white/15 transition-all duration-200" onClick={() => setIsModalOpen(false)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="h-6 w-6 text-white"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="flex flex-col md:flex-row mt-[20px]">
              <div className="md:w-1/2 w-full mt-5 pb-4 md:pb-0 border-b-2 md:border-b-0 md:border-r-2 border-indigo-100 md:pr-2">
                {(selectedTest?.type === 'AP_Calc_AB' || selectedTest?.type === 'AP_Calc_BC') ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: selectedTopic.content }}
                    className="ml-5 mr-5 max-h-[500px] overflow-y-auto overflow-x-hidden mt-2.5 scrollbar-thin scrollbar-thumb-indigo-200 scrollbar-track-transparent scrollbar-thumb-rounded-full hover:scrollbar-thumb-indigo-300"
                  />
                ) : (
                  <div
                    dangerouslySetInnerHTML={{ __html: selectedTopic.stem }}
                    className="mb-[50px] ml-5 mr-5 max-h-[500px] overflow-y-auto overflow-x-hidden mt-2.5 scrollbar-thin scrollbar-thumb-indigo-200 scrollbar-track-transparent scrollbar-thumb-rounded-full hover:scrollbar-thumb-indigo-300"
                  />
                )}
              </div>

              {/* Bottom section on mobile, right section on desktop */}
              <div className="w-full md:w-1/2 mt-[20px] md:ml-[20px] mr-[20px]">

                <div className="fixed bottom-[30px] left-0 right-0 flex justify-center z-50 block md:hidden">
                  <div className="flex items-center justify-center space-x-4 bg-black/80 backdrop-blur-xl px-5 py-3 rounded-full shadow-2xl border border-white/15">
                    {/* 왼쪽 화살표 버튼 */}
                    <button
                      className="text-white text-xl font-bold"
                      onClick={handlePreviousQuestion}
                    >
                      &lt;
                    </button>

                    <label className="flex items-center justify-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={hideExplanation}
                        onChange={handleChange}
                        className="form-checkbox h-5 w-5 text-gray-600"
                      />
                      <span className="text-white font-semibold">Hide Answer</span>
                    </label>

                    {/* 오른쪽 화살표 버튼 */}
                    <button
                      className="text-white text-xl font-bold"
                      onClick={handleNextQuestion}
                    >
                      &gt;
                    </button>
                  </div>
                </div>

                <div className="mt-4 mb-4 ml-0 md:ml-5">
                  <h2 className="text-xl font-bold bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 bg-clip-text text-transparent text-center md:text-left tracking-tight">
                    Question Review
                  </h2>
                  <div className="mt-1 h-0.5 w-16 bg-gradient-to-r from-blue-400 to-indigo-400 rounded-full mx-auto md:mx-0" />
                </div>

                <div className="my-2 max-w-[600px] overflow-y-auto">
                  {selectedTest?.type === 'AP_Calc_AB' || selectedTest?.type === 'AP_Calc_BC' || selectedTest?.type === 'apcalcbc' ? (
                    <div className="my-2 min-w-[100px] max-w-[600px] max-h-[580px] overflow-y-auto">
                      {soptions.map((option, index) => (
                        <Option3
                          key={index}
                          idx={index}
                          data={cleanOptionText(option)} // Pass cleaned option text
                        />
                      ))}
                    </div>
                  ) : (
                    selectedTopic.a != null ? (
                      <>
                        <Option idx={0} data={selectedTopic.a} />
                        <Option idx={1} data={selectedTopic.b} />
                        <Option idx={2} data={selectedTopic.c} />
                        <Option idx={3} data={selectedTopic.d} />
                      </>
                    ) : (
                      <input
                        className="ml-[20px] w-[90%] border-[1px] py-1 px-2 border-gray-300 outline-none rounded-md"
                        type="text"
                        readOnly
                      />
                    )
                  )}
                </div>

                {picked && selectedTopic?.correct_answer && (() => {
                  const userPicked = picked.charAt(0).toUpperCase() + picked.slice(1);
                  const correctAns = selectedTopic.correct_answer.slice(2, -2);
                  const isCorrect = userPicked.toUpperCase() === correctAns.toUpperCase();
                  return (
                    <div className={`mx-5 my-3 flex items-center gap-3 rounded-xl px-4 py-3 border ${isCorrect ? 'bg-emerald-50 border-emerald-200' : 'bg-rose-50 border-rose-200'}`}>
                      <span className={`text-lg font-bold ${isCorrect ? 'text-emerald-500' : 'text-rose-500'}`}>
                        {isCorrect ? '✓' : '✗'}
                      </span>
                      <div className="text-sm flex items-center gap-1.5 flex-wrap">
                        <span className="text-gray-500">Your answer:</span>
                        <span className={`font-bold px-2 py-0.5 rounded-md ${isCorrect ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'}`}>{userPicked}</span>
                        {!isCorrect && (
                          <>
                            <span className="text-gray-300">·</span>
                            <span className="text-gray-500">Correct:</span>
                            <span className="font-bold px-2 py-0.5 rounded-md bg-emerald-100 text-emerald-700">{correctAns}</span>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {selectedTest?.user_time && selectedTopic?.questionIds && (() => {
                  try {
                    const timeMap = typeof selectedTest.user_time === 'string' ? JSON.parse(selectedTest.user_time) : selectedTest.user_time;
                    const secs = timeMap[selectedTopic.questionIds];
                    if (!secs || secs < 1) return null;
                    const m = Math.floor(secs / 60);
                    const s = Math.floor(secs % 60);
                    const formatted = m > 0 ? `${m}m ${s}s` : `${s}s`;
                    return (
                      <div className="mx-5 mb-3 inline-flex items-center gap-1.5 bg-gray-100 border border-gray-200 rounded-full px-3 py-1">
                        <svg className="w-3 h-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span className="text-xs text-gray-400">Time spent:</span>
                        <span className="text-xs font-semibold text-gray-600">{formatted}</span>
                      </div>
                    );
                  } catch { return null; }
                })()}

                {picked && selectedTopic?.answer && !selectedTopic?.correct_answer && (() => {
                  const userPicked = picked.charAt(0).toUpperCase() + picked.slice(1);
                  const correctAns = selectedTopic.answer;
                  const isCorrect = userPicked.toUpperCase() === correctAns.toString().toUpperCase();
                  return (
                    <div className={`mx-5 my-3 flex items-center gap-3 rounded-xl px-4 py-3 border ${isCorrect ? 'bg-emerald-50 border-emerald-200' : 'bg-rose-50 border-rose-200'}`}>
                      <span className={`text-lg font-bold ${isCorrect ? 'text-emerald-500' : 'text-rose-500'}`}>
                        {isCorrect ? '✓' : '✗'}
                      </span>
                      <div className="text-sm flex items-center gap-1.5 flex-wrap">
                        <span className="text-gray-500">Your answer:</span>
                        <span className={`font-bold px-2 py-0.5 rounded-md ${isCorrect ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'}`}>{userPicked}</span>
                        {!isCorrect && (
                          <>
                            <span className="text-gray-300">·</span>
                            <span className="text-gray-500">Correct:</span>
                            <span className="font-bold px-2 py-0.5 rounded-md bg-emerald-100 text-emerald-700">{correctAns}</span>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })()}

                <div className="my-2 max-w-[600px] overflow-y-auto">
                  {!hideExplanation && (
                    <div className="mt-[20px] ml-[15px] mr-[15px] mb-[100px]">
                      {renderRationale(selectedTopic)}
                    </div>
                  )}
                </div>

              </div>
            </div>
          </div>
        )}

      </div>
      {/*
      {dashboard !== 0 &&
        dashboard !== 102 &&
        user.premium !== 2 &&
        user.premium !== 0 && (
          <DashboardAI
            subject={"SAT"}
            lastscore={lastTest}
            avg_sat={avg_sat}
            averageMCQ={avg_eng}
            averageFRQ={avg_math}
            esubjects={esubjects}
            msubjects={msubjects}
            allSATScores={allSATScores}
            analcomp={1}
            aiquestion={aiquestion}
            mocksatreview={mocksatreview}
            satanal={satanal}
            setdashboard={setdashboard}
          />
        )}
*/}
    </div >
  );
};

export default Dashboard;

const Option = ({ idx, data }) => {
  return (
    <div className="px-3 py-1">
      <motion.div
        whileTap={{ scale: 0.98 }}
        className="flex items-start gap-3 w-full border border-gray-200 rounded-xl p-3 cursor-pointer bg-white hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 shadow-sm hover:shadow-md"
      >
        <span className="shrink-0 flex items-center justify-center w-7 h-7 rounded-full border border-gray-300 bg-gray-100 text-gray-600 text-xs font-bold">
          {getOptionLetter(idx)}
        </span>
        <div className="flex-1 text-sm leading-relaxed" dangerouslySetInnerHTML={{ __html: data }} />
      </motion.div>
    </div>
  );
};

function getOptionLetter(idx) {
  switch (idx) {
    case 0:
      return 'A';
    case 1:
      return 'B';
    case 2:
      return 'C';
    case 3:
      return 'D';
    default:
      return "A";
  }
}

const Option2 = ({ sat, currentQuestion, option }) => {
  const optionLetter = option.charAt(0); // Extract the first character as the option letter
  const optionText = option.slice(2).trim(); // Extract the text part after the letter and period
  return (
    <div className="flex flex-row gap-1">
      <motion.div whileTap={{ scale: 0.98 }}
        className={`flex flex-row w-full ${currentQuestion.selectedOption === optionLetter.toLowerCase() ? "border-[2px]" : "border-[1px]"} rounded-md ${currentQuestion.selectedOption === optionLetter.toLowerCase() ? "border-blue-700 bg-blue-100" : "border-black"} gap-2 p-1 m-3 cursor-pointer relative"}`}
      >
        <div className="flex flex-row items-center">
          <p className="flex flex-row items-center justify-center p-1 w-6 h-6 border-[1px] border-black rounded-full">
            {optionLetter}
          </p>
        </div>
        <div className="flex flex-row items-center p-[2px]">
          {sat === "math" ? (<>
            <div dangerouslySetInnerHTML={{ __html: optionText }} />
          </>
          ) : (
            <p>{optionText}</p>
          )}
        </div>
      </motion.div>
    </div>
  );
}

const Option3 = ({ currentQuestion, idx, data }) => {
  return (
    <div className="px-3 py-1">
      <motion.div
        whileTap={{ scale: 0.98 }}
        className="flex items-start gap-3 w-full border border-gray-200 rounded-xl p-3 cursor-pointer bg-white hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 shadow-sm hover:shadow-md"
      >
        <span className="shrink-0 flex items-center justify-center w-7 h-7 rounded-full border border-gray-300 bg-gray-100 text-gray-600 text-xs font-bold">
          {getOptionLetter2(idx)}
        </span>
        <div className="flex-1 text-sm leading-relaxed" dangerouslySetInnerHTML={{ __html: data }} />
      </motion.div>
    </div>
  );
};

function getOptionLetter2(idx) {
  const letters = ["A", "B", "C", "D", "E"];
  return letters[idx] || "A";
}